/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {effectiveThemeMode} from './ThemeStore';
import {DLSThemeModes} from './types';

/**
 * Writes the effective theme mode to `<html data-theme-mode>` synchronously,
 * including the current value at the time of the call, and keeps the
 * attribute in step with every later change. Not invoked on module
 * evaluation; only the host application calls it. Without a `document`,
 * such as during server-side rendering, no attribute is written.
 *
 * ```typescript
 * import {bindThemeModeAttribute} from '@ion/dls/src/theme/ThemeModeAttribute';
 * ...
 *
 * const unbind = bindThemeModeAttribute();
 *
 * // cleanup...
 * unbind();
 * ```
 *
 * @returns Unsubscribe function which stops updating the attribute.
 */
export const bindThemeModeAttribute = (): (() => void) => {
  return effectiveThemeMode.subscribe((mode: DLSThemeModes) => {
    if (typeof document !== 'undefined') {
      document.documentElement.dataset.themeMode = mode;
    }
  });
};
